import { Controller } from "@hotwired/stimulus"

// AI Composer (#636) — swaps the new-article modal between the standard article
// form and the AI Composer panel. Each panel is a target; the trigger buttons
// call showComposer / showStandard. Pure show/hide, no navigation, so it works
// identically inside the web <el-dialog> and the iOS native sheet.
export default class extends Controller {
  static targets = ["standard", "composer"]

  showComposer() {
    this.standardTarget.hidden = true
    this.composerTarget.hidden = false
  }

  showStandard() {
    this.composerTarget.hidden = true
    this.standardTarget.hidden = false
  }
}
